

export const environment = {
    production: false,
    url: 'https://bbeatz-api-mis-staging.stacknize.com/',
    siteKey: '6Lc7M2QrAAAAAOxdRjBa2LNlqD2_ZK2GfHyj6mud'
}